
export default {
  data() {
    return {
      currentPath: '',
      currentMenu: null,
      btnPermissions: [],
    };
  },
  methods: {
       // 获取菜单列表
      getMenuList() {
        let productGuid = this.$route.query.productGuid || localStorage.productGuid;
        let reqUrl = `/${serverConfig.msCommonAdminPlatformAuthService}/menu/data/get-menu-by-currentuser?appType=01&tenantGuid=${localStorage.guid}&productGuid=${productGuid}&appSideIdentifier=scm_operative`;
        this.api.get(reqUrl).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let menuList = res.data.data;
            this.currentPath = this.$route.path;
            this.currentMenu = this.getNodeByPath(this.currentPath, menuList);
            this.getBtnPermissions(this.currentMenu);
            console.log(this.currentMenu, 'currentMenu');
          }
        });
      },
      // 获取按钮list
      getBtnPermissions(currentMenu) {
        if (currentMenu && Array.isArray(currentMenu.children)) {
          this.btnPermissions = currentMenu.children.filter((item) => item.menuType === 'F');
        }
      },
      // 按钮权限匹配
      getBtnPermissionsByName(menuName) {
        return (
          (!this.btnPermissions.length || this.btnPermissions.find((item) => item.menuName === menuName)) &&
          this.currentMenu
        );
      },
      getNodeByPath(path, tree) {
        //设置结果
        let result;
        if (!tree) {
          return;
        }
        for (let i = 0; i < tree.length; i++) {
          let item = tree[i];
          if (item.path == path) {
            result = item;
            return result;
          } else if (item.children && item.children.length > 0) {
            result = this.getNodeByPath(path, item.children);
            if (result) {
              return result;
            }
          }
        }
        //如果执行循环中都没有return，则在此return
        return result;
      },
  }
};


